export default __webpack_public_path__ + "static/media/circleci.18a366c8.svg";